import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface MrfConfirmAlertData {
  title?: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
}

@Component({
  selector: 'app-mrf-confirm-alert',
  templateUrl: './mrf-confirm-alert.component.html',
  styleUrls: ['./mrf-confirm-alert.component.scss'],
})
export class MrfConfirmAlertComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: MrfConfirmAlertData,
    private dialogRef: MatDialogRef<MrfConfirmAlertComponent>
  ) {}

  get title(): string {
    return this.data.title?.trim() || 'Warning';
  }

  get confirmLabel(): string {
    return this.data.confirmLabel?.trim() || 'Confirm';
  }

  get cancelLabel(): string {
    return this.data.cancelLabel?.trim() || 'No';
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }
}
